import { millisecondsInMinute } from 'helpers/timeConsts';

interface TimeOption {
  hours?: number;
  minutes?: number;
}

const maxHours = 12;
const maxMinutes = maxHours * 60;
const limitHours = 24 - maxHours - 1;

const generateTimeOptions = ({ hours = 0, minutes = 0 }: TimeOption) => {
  const options: string[] = [];
  const start = new Date();
  const minutesToSet = minutes < 0 ? 0 : minutes;
  start.setHours(hours, minutesToSet, 0, 0);

  let increment = 5;

  for (let minute = 0; minute < maxMinutes; minute += increment) {
    const time = new Date(start.getTime() + minute * millisecondsInMinute);

    const adjustedHours = time.getHours() % 24;

    if (hours > limitHours && time.getHours() === 0) {
      options.push('24:00');
      break;
    }

    options.push(
      `${adjustedHours.toString().padStart(2, '0')}:${time
        .getMinutes()
        .toString()
        .padStart(2, '0')}`,
    );

    if (minute >= 55) {
      increment = 15;
    }
  }

  return options;
};

export default generateTimeOptions;
